import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navigation from '../../Layouts/Navigation/Navigation';
import { BASE_URL } from '../../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding } from '@fortawesome/free-solid-svg-icons';

function AdminApartments() {
  const navigate = useNavigate();
  const [towers, setTowers] = useState([]);

  const handleCardClick = (id_torre) => {
    navigate(`/controlApartments/${id_torre}`);
  };

  useEffect(() => {
    const fetchTowers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/towers`);
        setTowers(response.data);
        console.log(response.data);
      } catch (error) {
        console.error('Error fetching towers:', error);
      }
    };

    fetchTowers();
  }, []);

  return (
    <>
      <Navigation />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl font-bold text-gray-800 text-center mb-10">
            Administrar Apartamentos
          </h1>

          <div className="space-y-6">
            {towers.map((tower) => (
              <div
                key={tower.id_torre}
                onClick={() => handleCardClick(tower.id_torre)}
                className="group relative bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden cursor-pointer"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-primary-500 to-primary-700 opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
                
                <div className="flex items-center justify-between p-6">
                  <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-800 mb-2 group-hover:text-primary-600 transition-colors">
                      {tower.nombre}
                    </h2>
                    <p className="text-gray-600">
                      Click para administrar los apartamentos de esta torre
                    </p>
                  </div>

                  <div className="relative">
                    <div className="w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-700 rounded-xl flex items-center justify-center shadow-lg transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300">
                      <FontAwesomeIcon icon={faBuilding} className="h-10 w-10 text-white" />
                    </div>
                    <div className="absolute inset-0 bg-white opacity-20 rounded-xl blur-sm"></div>
                  </div>
                </div>

                <div className="h-1 w-0 group-hover:w-full bg-gradient-to-r from-primary-500 to-primary-700 transition-all duration-500"></div>
              </div>
            ))}
          </div>

          {towers.length === 0 && (
            <div className="text-center py-12">
              <FontAwesomeIcon icon={faBuilding} className="h-24 w-24 text-gray-300 mx-auto mb-4" />
              <p className="text-xl text-gray-500">No hay torres registradas</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AdminApartments;
